import React from 'react';
import { createRoot } from 'react-dom/client';

import { commitHash } from '@paragon/client-tools';
import { sealingService } from '@paragon/data-connections';
import { attemptAutomaticLogInWithStoredToken, initializeDataConnectionsAndLoginTools } from '@paragon/login-tools';

import { savePageAnnotations } from './actions/annotations';
import { startApp } from './actions/startAppActions';
import App from './components/App';
import { configureJobUnlocker } from './modules/jobLocking';
import { store } from './store';

if (commitHash != null) console.log(`Commit hash: ${commitHash}`);

initializeDataConnectionsAndLoginTools(store);
configureJobUnlocker(store);

store.dispatch(attemptAutomaticLogInWithStoredToken()).then((user) => {
  if (user) {
    store.dispatch(startApp());
  }
});

const root = createRoot(document.querySelector('.root')!);
root.render(<App reduxStore={store} />);

window.onbeforeunload = () => {
  const state = store.getState();
  const { jobId } = state.job;

  if (jobId == null) return true;

  if (state.annotations.pagesWithModifications.length > 0) {
    store.dispatch(savePageAnnotations());
  }

  sealingService.jobs.close(jobId);

  return false;
};
